import * as React from 'react';
import { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import ClipboardCopy from '../../../../components/ClipboardCopy';
import { CustomFormControl } from '../../../../components/Form/FormControl';
import OutlinedButton from '../../../../components/Buttons/OutlinedButton';
import { linkToCopy } from '../../../../functions/linkUtils';
import { IReviewDocument } from '../../../../common/request/interfaces/reviewDocument';
import { EmailButtonWithParams } from '../../../../components/Buttons/EmailButtonWithParams';
import { documentsToNameList } from '../../../../functions/documents/documentUtils';
import { TwilioError } from '../../../../integrations/twilio/error/types';
import { twilioErrorMapper } from '../../../../integrations/twilio/error/twilio-error-mapper';
import { twilioErrorHelpTextMapper } from '../../../../integrations/twilio/error/twilio-error-help-text-mapper';

type InputProps = {
  request: IReviewDocument;
  candidateUploadLink: string;
  onChangePhone: (v: string) => void;
  error?: TwilioError;
};

export const MessageDeliveryErrorForm = ({
  request,
  candidateUploadLink,
  onChangePhone,
  error,
}: InputProps) => {
  const { t } = useTranslation();

  const [isNewPhoneNumber, setIsNewPhoneNumber] = useState(false);
  const [newPhone, setNewPhone] = useState(request.candidatePhone.toString());

  const handleChangePhone = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const v = event.target.value.toString();
    setNewPhone(v);
    setIsNewPhoneNumber(!!v && request.candidatePhone !== v);
  };

  const handleSubmitPhone = () => {
    onChangePhone(newPhone);
  };

  return (
    <div className={styles.root}>
      <div className={styles.description}>
        <div>
          We could not deliver the request to {request.candidateFullName}. We
          received the error:
        </div>
        <div className={styles.error}>{twilioErrorMapper(error)}</div>
        <div
          className={styles.info}
          dangerouslySetInnerHTML={{ __html: twilioErrorHelpTextMapper(error) }}
        />
      </div>
      <div className={styles.actions}>
        <CustomFormControl
          label={t('RequestForm.label.candidatePhone')}
          inputProps={{
            value: newPhone,
            onChange: handleChangePhone,
          }}
        />
        <ClipboardCopy
          label="Driver Unique Upload Link"
          isActive={true}
          copyText={linkToCopy(candidateUploadLink)}
        />
      </div>
      <div className={clsx(styles.actions, styles.buttons)}>
        <OutlinedButton
          disabled={!isNewPhoneNumber}
          onClick={handleSubmitPhone}
        >
          Save number and resend
        </OutlinedButton>
        {request.candidateEmail && (
          <EmailButtonWithParams
            email={request.candidateEmail}
            subject={`Request for ${documentsToNameList(
              request.documentsNeeded
            )} from ${request.requestedByUserFullName}`}
            body={`Hi ${
              request.candidateFullName.split(' ')[0]
            }, please navigate to this link on your phone to upload the following document to me. ${documentsToNameList(
              request.documentsNeeded
            )}: ${candidateUploadLink}`}
          >
            Send Email
          </EmailButtonWithParams>
        )}
      </div>
    </div>
  );
};
